import React, { useCallback, useEffect, useRef, useState } from 'react';

// Recherche des notes faite par le serveur (/api/notes ou /api/admin/notes/search) :
// le texte des dissertations ne quitte pas le serveur, le navigateur ne reçoit que les résultats.
// `fetcher` : fetch pour les lecteurs, authFetch pour l'admin.
export function useNotesSearch(endpoint, fetcher, query, subject, page = 1) {
  const [data, setData] = useState(null);       // { total, subjects, notes }
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  useEffect(() => {
    const ctrl = new AbortController();
    // on attend la fin de la frappe avant d'interroger le serveur
    const timer = setTimeout(() => {
      const p = new URLSearchParams();
      if (query.trim()) p.set('q', query.trim());
      if (subject) p.set('subject', subject);
      if (page > 1) p.set('page', page);
      setLoading(true);
      fetcherRef.current(`${endpoint}${p.toString() ? '?' + p : ''}`, { signal: ctrl.signal })
        .then(r => r.ok ? r.json() : Promise.reject())
        .then(d => { setData(d); setError(false); setLoading(false); })
        .catch(e => { if (e && e.name === 'AbortError') return; setError(true); setLoading(false); });
    }, data ? 250 : 0);
    return () => { clearTimeout(timer); ctrl.abort(); };
    // eslint-disable-next-line
  }, [endpoint, query, subject, page, tick]);

  const reload = useCallback(() => setTick(t => t + 1), []);
  return { data, error, loading, reload };
}

